// extracted by mini-css-extract-plugin
module.exports = {"actions":"Table_actions__1c0sE","colMaxWidth":"Table_colMaxWidth__1g7Et"};